import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Employee } from '@coin/shared/core/util-models';
import { ActionDef } from '@ngxs/store';
import { OrganisationService } from '../../models/organisation-service.model';

@Component({
  selector: 'coin-c-org-tree-overview',
  templateUrl: './org-tree-overview.component.html',
  styleUrls: ['./org-tree-overview.component.scss'],
  standalone: false
})
export class OrgTreeOverviewComponent {
  @Input() rootEmployee: Employee;
  @Input() selectedEmployeeId: string;
  @Input() service: OrganisationService;
  @Input() seasonId?: string;
  @Input() customOpenEmployeeInViewAction: ActionDef;
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close = new EventEmitter<void>();

  public onClose(): void {
    this.close.emit();
  }
}
